import { isDevMode } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { FromObject } from '@cbuild/utils';
export class ActiveFormStateControl {
  public infoForm: FormGroup;
  public clickedSubmit = false;
  public dataSentOnce = false;
  public initialFormValue: FromObject;

  // tslint:disable-next-line: no-empty no-any
  constructor(...args: Array<any>) {}

  public getControl(name: string): AbstractControl {
    return this.infoForm.get(name)!;
  }

  public getGroup(name: string): FormGroup {
    return this.infoForm.get(name) as FormGroup;
  }

  public isInvalid(name?: string): boolean {
    if (isDevMode() && !name) {
      throw new Error('FormControl name not provided in isInvalid()');
    }
    const control = this.getControl(name!);
    return control.invalid;
  }

  public initializeFormData(): void {
    this.initialFormValue = this.infoForm.value;
  }

  public get canDisableSave(): boolean {
    const latestFormValue = JSON.stringify(this.infoForm?.value);
    const initialFormValue = JSON.stringify(this.initialFormValue);
    return initialFormValue === latestFormValue || this.dataSentOnce;
  }
}
